<template>
  <v-col cols="12" md="4">
    <v-card-subtitle class="mt-2 pt-0">
      <v-icon left>{{ eatingIcon }}</v-icon>
      <span
        class="font-weight-bold">{{  $vuetify.lang.t('$vuetify.map.driverSettings.tabs.eating') }}</span>
    </v-card-subtitle>
    <v-row class="mx-auto ml-5" no-gutters justify="start">
      <v-col cols="12" md="6" class="pr-md-2" align-self="start">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-center" dense
                      @change="filterValueChanged($event, 'eatState')"
                      hide-details v-model="filters.eatState"></v-checkbox>
          <v-select v-model="foodEntry.eatState" :items="eatList" style="max-width: 300px"
                    :disabled="isFilter && !filters.eatState"
                    :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.eatState`)">
            <template v-slot:selection="data">
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.DetectorFoodEat.${data.item}`) }}
            </template>
            <template v-slot:item="data">
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.DetectorFoodEat.${data.item}`) }}
            </template>
          </v-select>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="pl-md-2" align-self="start">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-center" dense
                      @change="filterValueChanged($event, 'drinkState')"
                      hide-details v-model="filters.drinkState"></v-checkbox>
          <v-select v-model="foodEntry.drinkState" :items="drinkList" style="max-width: 300px"
                    :disabled="isFilter && !filters.drinkState"
                    :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.drinkState`)">
            <template v-slot:selection="data">
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.DetectorFoodDrink.${data.item}`) }}
            </template>
            <template v-slot:item="data">
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.DetectorFoodDrink.${data.item}`) }}
            </template>
          </v-select>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { mdiFood } from '@mdi/js'
import criticalDatasetMixin from '../../../mixins/criticalDatasetMixin'
import { CriticalDatasetLabels, DetectorFoodDrink, DetectorFoodEat } from '../../../enum'
import { DetectorFoodEntry } from '../../../models/criticalDataset/DetectorFoodEntry'

export default {
  name: 'criticalDatasetFoodDetector',
  mixins: [criticalDatasetMixin(DetectorFoodEntry, 'food')],
  props: {
    foodEntry: DetectorFoodEntry
  },
  data: () => ({
    eatList: Object.values(DetectorFoodEat),
    drinkList: Object.values(DetectorFoodDrink),
    eatingIcon: mdiFood
  }),
  created () {
    this['CriticalDatasetLabels'] = CriticalDatasetLabels
  }
}
</script>

<style scoped>

</style>
